import { createStructuredSelector } from 'reselect'

const devices = ({ devices }) => devices.getIn(['devicesList'], [])
const loading = ({ devices }) => devices.getIn(['loading'], false)

export default createStructuredSelector({
  loading,
  devices
})
